module.exports = __webpack_public_path__ + "img/razzo-head-page-3.2222677c.webp";